// extracted by mini-css-extract-plugin
module.exports = {"widgetList":"_3XiS2X2bD15Df4gfOCr7L1","widgetListItem":"_2JqlzonsZOLkS4eDFCnCJP"};